import { all, call, put, takeLatest, takeEvery, select } from 'redux-saga/effects';
import { axiosSSO } from 'config';
import { notificationHandler } from 'utils/utils';
import * as homeSelectors from 'store/homePageSlice/homePageSelectors';
import { formControlActions } from 'store/formControlSlice/formControlSlice';
import { addUserActions } from './addUserSlice';
import { userConfigurationSaga } from 'store/formControlSlice/userConfigurationSaga';
import { selectSelectedUser } from 'store/addUserSlice/addUserSelectors';

export function* fetchUsers() {
    try {
        const response = yield axiosSSO(`/user/active`);
        const { data } = response;

        const modifiedAuthorizedList = [];

        data.forEach((el) => {
            const modifiedAuthorizedPerson = {
                ...el,
                authTypes: [],
            };
            modifiedAuthorizedList.push(modifiedAuthorizedPerson);
        });

        const arrayHashmap = modifiedAuthorizedList.reduce((obj, item) => {
            if (obj[item.id]) {
                if (obj[item.id].authTypes.length === 0) {
                    obj[item.id].authTypes = [obj[item.id].authType, item.authType];
                } else {
                    obj[item.id].authTypes = [...obj[item.id].authTypes, item.authType];
                }
            } else {
                obj[item.id] = { ...item };
            }
            return obj;
        }, {});
        const mergedArray = Object.values(arrayHashmap);

        yield put(addUserActions.fetchUsersSuccess(mergedArray));
    } catch (err) {
        yield put(formControlActions.submitFormFailed(err));
        yield notificationHandler({ title: 'Error fetching Users' });
    }
}

export function* fetchSelectedUserRoles({ payload: dataPayload }) {
    const allApps = yield select(homeSelectors.selectApps);
    const allRoles = yield select(homeSelectors.selectRoles);

    try {
        const response = yield axiosSSO(`/user/${dataPayload.userId}`);

        const apps = [];
        response?.data?.applicationRoles?.forEach((element) => {
            const roleAndApps = {};

            for (let i = 0; i < allApps.length; i++) {
                if (allApps[i]?.id === element?.applicationId) {
                    roleAndApps.app = allApps[i];
                }
            }
            for (let i = 0; i < allRoles.length; i++) {
                if (allRoles[i]?.id === element?.roleId) {
                    roleAndApps.role = allRoles[i];
                }
            }
            apps.push({ ...roleAndApps.app, ...roleAndApps.role, id: element.id, applicationId: element.applicationId, roleId: element.roleId });
        });
        response.data.roles = apps;

        yield put(addUserActions.fetchSelectedUserRolesSuccess(response.data.roles));
    } catch (err) {
        yield call(notificationHandler, {
            err,
            action: addUserActions.fetchUsersStart,
            title: 'Error fetching users',
        });
    }
}

export function* deleteUserRole({ payload: dataPayload }) {
    const selectedUser = yield select(selectSelectedUser);
    try {
        const data = {
            id: dataPayload.userId,
            applicationRoles: [...dataPayload.selectedUserRoles],
            email: selectedUser.email || null,
        };
        const response = yield axiosSSO.put(`/user`, data);

        if (response.status === 200) {
            yield notificationHandler({ title: 'Successfully removed role', variant: 'success' });
            yield put(addUserActions.fetchUsersStart());
            yield put(addUserActions.fetchSelectedUserRolesStart({ userId: dataPayload.userId }));
            yield put(addUserActions.setAddRolePopupVisible(false));
            yield put(addUserActions.setSelectedRole(null));
        }
    } catch (err) {
        yield notificationHandler({ title: 'Error removing role' });
    }
}
export function* onFetchSelectedUserRolesStart() {
    yield takeLatest(addUserActions.fetchSelectedUserRolesStart.type, fetchSelectedUserRoles);
}

export function* onFetchUsers() {
    yield takeEvery(addUserActions.fetchUsersStart, fetchUsers);
}

export function* onAddUser() {
    yield takeLatest(addUserActions.addUsers, userConfigurationSaga);
}

export function* onDeleteUserRoles() {
    yield takeEvery(addUserActions.deleteUserRoles, deleteUserRole);
}

export function* onAddyUserRoles() {
    yield takeEvery(addUserActions.addUserRoles, userConfigurationSaga);
}
export function* addUserSaga() {
    yield all([call(onFetchUsers), call(onDeleteUserRoles), call(onAddUser), call(onFetchSelectedUserRolesStart), call(onAddyUserRoles)]);
}
